"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingTypeLabels = exports.BillingType = void 0;
var BillingType;
(function (BillingType) {
    BillingType["DIRECT"] = "DIRECT";
    BillingType["AGENCY_FINANCED"] = "AGENCY_FINANCED";
    BillingType["AGENCY_PAY_IN_FULL"] = "AGENCY_PAY_IN_FULL";
})(BillingType = exports.BillingType || (exports.BillingType = {}));
exports.BillingTypeLabels = (_a = {},
    _a[BillingType.DIRECT] = 'Direct',
    _a[BillingType.AGENCY_FINANCED] = 'Agency financed',
    _a[BillingType.AGENCY_PAY_IN_FULL] = 'Agency pay in full',
    _a);
